'use client';

import { useCallback, useEffect, useState } from 'react';

export const useIframeLoadTracker = () => {
  const [loadingToken, setLoadingToken] = useState(0);
  const startLoading = useCallback(() => setLoadingToken((t) => t + 1), []);
  const stopLoading = useCallback(() => setLoadingToken(0), []);

  useEffect(() => {
    if (!loadingToken) return;

    let cancelled = false;
    let observer: MutationObserver | null = null;
    let iframeTimer: NodeJS.Timeout;
    let iframe: HTMLIFrameElement | null = null;

    const done = () => {
      if (cancelled) return;
      cancelled = true;
      stopLoading();
      clearTimeout(iframeTimer);
      observer?.disconnect();
      iframe?.removeEventListener('load', done);
    };

    const globalTimer = setTimeout(done, 8000);

    const tryAttach = () => {
      iframe = document.querySelector('.live-preview-window iframe') as HTMLIFrameElement | null;
      if (!iframe) return false;
      iframe.addEventListener('load', done);
      iframeTimer = setTimeout(done, 5000);
      observer?.disconnect();
      return true;
    };

    if (!tryAttach()) {
      observer = new MutationObserver(() => {
        if (tryAttach()) observer?.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    return () => {
      cancelled = true;
      clearTimeout(globalTimer);
      clearTimeout(iframeTimer);
      observer?.disconnect();
      iframe?.removeEventListener('load', done);
    };
  }, [loadingToken, stopLoading]);

  return { isLoading: loadingToken > 0, startLoading };
};
